<!--  -->
<template>
    <!-- <div class="sub-nav" :class="{active: isActive}" v-click-outside:[el]="{all}"> -->
    <div class="sub-nav" :class="{active: isActive,vertical}" v-click-outside="close">
        <div :style="paddingLeft" class="sub-nav-title" @click="onClick">
            <slot name="title"></slot>
            <template v-if="$parent.$options.name === 'g-nav' || vertical">
                <g-icon v-if="visible" icon="up" />
                <g-icon v-else icon="down" />
            </template>
            <template v-else>
                <g-icon v-if="visible" icon="left" />
                <g-icon v-else icon="right" />
            </template>
        </div>
        <transition v-if="vertical" @enter="enter" @after-enter="afterEnter" @leave="leave" @after-leave="afterLeave">
            <div class="sub-nav-popover" :class="{vertical}" ref="popover" v-show="visible">
                <slot></slot>
            </div>
        </transition>
        <div v-else class="sub-nav-popover" ref="popover" v-show="visible">
            <slot></slot>
        </div>

        
    </div>
</template>

<script>
import directives from '../directives-one'
import Icon from '../icon'
export default {
    name: 'g-sub-nav',
    data() {
        return {
            visible: false,
            isActive: false,
            // el:'popover',
            // all:this,
            index:0
        }
    },
    inject: ['eventBus', 'vertical'],
    components: {
        'g-icon': Icon
    },
    directives: {
        'click-outside': directives['click-outside']
    },
    methods: {
        enter(el,done) {
            let { height } = el.getBoundingClientRect()
            el.style.height = 0
            el.getBoundingClientRect()
            el.style.height = `${height}px`
            el.addEventListener('transitionend',()=> {
                done()
            })
        },
        afterEnter(el){
            el.style.height= 'auto'
        },
        leave(el,done) {
            let { height } = el.getBoundingClientRect()
            el.style.height = `${height}px`
            el.getBoundingClientRect()
            el.style.height = 0
            el.addEventListener('transitionend',()=> {
                done()
            })
        },
        afterLeave(el,done) {
            el.style.height = 'auto'
        },
        onClick() {
            this.visible = !this.visible
        },
        getChildrenList(children) {
            const list = []
            const fn = arr => {
                arr.forEach(vm => {
                    vm.name && list.push(vm.name)
                    if (vm.$children.length > 0) {
                        fn(vm.$children)
                    }
                })
            }
            fn(children)
            return list
        },
        close() {
            this.visible = false
        }
    },
    mounted() {
        this.eventBus && this.eventBus.$on('mountedSelect', (name) => {
            const list = this.getChildrenList(this.$children)
            let flag = false
            flag = list.indexOf(name) > -1
            this.isActive = flag
        })
        if(this.$parent.$options.name === 'g-sub-nav'){
            this.index = this.$parent.index +1
        }
    },
    computed: {
        paddingLeft(){
            return {
                'padding-left': `${this.index *10 + 20}px`
            }
        }
    }
}
</script>
<style scoped lang='scss'>
@import '../var';
.sub-nav {
    position: relative;
    box-sizing: border-box;
    &.active {
        > .sub-nav-title {
            color: #000;
            > .icon {
                fill: #000;
            }
        }
    }
    &-title {
        padding: 10px 20px;
        cursor: pointer;
        font-size: $font-size;
        position: relative;
        min-width: 9em;
        > .icon {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            fill: $light-color;
        }
    }
    &-popover {
        position: absolute;
        top: 100%;
        left: 0;
        white-space: nowrap;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        background-color: #fff;
        margin-top: 1px;
        border-radius: 2px;
        font-size: $small-font-size;
        min-width: 10em;
        transition: height 250ms;
        .nav-item {
            font-size: $small-font-size;
        }
        &.vertical {
            position: static;
            box-shadow: none;
            overflow: hidden;
        }
    }
}
.sub-nav .sub-nav .sub-nav-popover:not(.vertical) {
    top: 0;
    left: 100%;
    margin-left: 6px;
}
.nav {
    > .sub-nav {
        &.active {
            &:not(.vertical) {
                position: relative;
                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    border-bottom: 2px solid $blue;
                }
            }
        }
    }
}
</style>